import LeagueSeasonPlayerIndex from './LeagueSeasonPlayerIndex';
import LeagueSeasonPlayerSettings from './LeagueSeasonPlayerSettings';
import LeagueSeasonPlayerSingle from './LeagueSeasonPlayerSingle';

export default function (app) {

    const settings = LeagueSeasonPlayerSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    LeagueSeasonPlayerIndex(app, settings);

    LeagueSeasonPlayerSingle(app, settings);

}